import swal from "sweetalert";
import {
  CREATE_REJECT_FAIL,
  CREATE_REJECT_REQUEST,
  CREATE_REJECT_SUCCESS,
  FETCH_REJECT_FAIL,
  FETCH_REJECT_REQUEST,
  FETCH_REJECT_SUCCESS,
  REFUSE_REJECT_FAIL,
  REFUSE_REJECT_REQUEST,
  REFUSE_REJECT_SUCCESS,
} from "../../ActionType/RejectTypes/RejectType";
import { api } from "../../Api/api";
import { getToken } from "../login";
import { getVisitAction } from "../VisitAction/VisitAction";

export const createRejectAction =
  (visitId, note, patientId,dateManualy) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_REJECT_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "reject/create",
        { note, visit_id: visitId,date:dateManualy },
        config
      );
      const { status, data } = response;
      console.log(response);
      if (status == 201) {
        dispatch(getVisitAction(patientId));
        dispatch(getVisitAction(patientId));
        swal({
          title: "Good job!",
          text: "Reject was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });

        dispatch({
          type: CREATE_REJECT_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: CREATE_REJECT_FAIL,
        payload: [],
      });
    }
  };

export const refuseRejectAction = (visitId, rejectId) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: REFUSE_REJECT_REQUEST,
    payload: [],
  });
  try {
    const response = await api.post(
      "reject/refuse",
      { rejectId, visit_id: visitId },
      config
    );
    const { status, data } = response;
    console.log(response);
    if (status == 200) {
      dispatch(getRejectAction(10, 0));
      dispatch(getRejectAction(10, 0));
      swal({
        title: "Good job!",
        text: "Refused Reject was saved Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });

      dispatch({
        type: REFUSE_REJECT_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    console.log(error);
    dispatch({
      type: REFUSE_REJECT_FAIL,
      payload: [],
    });
  }
};

export const getRejectAction =
  (perPage, page, fullname, code, gender, phone, birthDate, from, to) =>
  async (dispatch) => {
    const branch_id = localStorage.getItem("branch_id");
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        perPage,
        page,
        fullname,
        code,
        gender,
        phone,
        birthDate,
        branch_id,
        from,
        to,
      },
    };
    dispatch({
      type: FETCH_REJECT_REQUEST,
      payload: [],
    });
    try {
      const response = await api.get("reject", config);
      const { status, data } = response;

      if (status == 200) {
        dispatch({
          type: FETCH_REJECT_SUCCESS,
          payload: { data: data.data, total: data.total },
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: FETCH_REJECT_FAIL,
        payload: [],
      });
    }
  };
